import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/Babawale Suit - Cybersecurity Practice Lead.png";
import AmandaImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Amanda Suit - Cybersecurity and Business Analysis and Project Management Support Person.png";
import PrincewillImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/PRINCEWILL SUIT - AI Automation Practice Lead.png";
import OmodaraImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMODARA SUIT -  Product and Digital Marketing Practice Lead.png";
import IdaraImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Idara Suit -  Data School Support Person.png";

import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon4 from "../../../../../assets/images/png/courses/icons/icon4.svg";

import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/liyide.webp";

import OyinImage from "../../../../../assets/images/png/courses/testimonies/oyin.png";
import JumokeImage from "../../../../../assets/images/png/courses/testimonies/jumoke.png";
import OkechukwuImage from "../../../../../assets/images/png/courses/testimonies/okechukwu.png";
import BanjoImage from "../../../../../assets/images/png/courses/testimonies/banjo.png";
import YemiImage from "../../../../../assets/images/png/courses/testimonies/yemi.png";
import NicholasImage from "../../../../../assets/images/png/courses/testimonies/nicholas.png";
import OvianihinImage from "../../../../../assets/images/png/courses/testimonies/Ovianihin.png";
import AdebamboImage from "../../../../../assets/images/png/courses/testimonies/adebambo.png";
import JoshuaImage from "../../../../../assets/images/png/courses/testimonies/joshua.png";
import KoredeImage from "../../../../../assets/images/png/courses/testimonies/korede.png";
import StephnoraImage from "../../../../../assets/images/png/courses/testimonies/stephnora.png";
import NwokoloImage from "../../../../../assets/images/png/courses/testimonies/nwokolo.png";
import WisdomImage from "../../../../../assets/images/png/courses/testimonies/wisdom.png";
import KunleImage from "../../../../../assets/images/png/courses/testimonies/kunle.png";
import EnaImage from "../../../../../assets/images/png/courses/testimonies/ena.png";
import KennethImage from "../../../../../assets/images/png/courses/testimonies/keneth.png";
import CynthiaImage from "../../../../../assets/images/png/courses/testimonies/cynthia.png";
import BabatundeImage from "../../../../../assets/images/png/courses/testimonies/babatunde.png";
import BenjaminImage from "../../../../../assets/images/png/courses/testimonies/benjamin.png";
import PreciousImage from "../../../../../assets/images/png/courses/testimonies/precious.png";
import FadeelahImage from "../../../../../assets/images/png/courses/testimonies/fadeelah.png";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";

export const cyberSecurity = {
  id: 1,
  tag: "FOR STARTERS",
  title: "Cybersecurity Bootcamp",
  seoTitle: "Cybersecurity Bootcamp Nigeria | Ethical Hacking & SecOps",
  description: `
  Develop the technical knowledge, analytical mindset, and practical experience needed to identify
  threats, secure enterprise environments, and respond to modern cyber attacks. Throughout this
  bootcamp, you'll work with industry-standard tools like Kali Linux, Wireshark, Nessus, and Active
  Directory while solving realistic security challenges that mirror the work of professional
  cybersecurity teams — preparing you for roles such as SOC Analyst, Cybersecurity Analyst, and
  Penetration Testing Associate.
    `,
  heroSubtitle: `Master cybersecurity through an immersive 20-week instructor-led bootcamp designed to equip beginners and career changers with the practical skills required to secure modern organisations. This program combines theoretical knowledge with extensive hands-on laboratories, real-world attack simulations, enterprise security projects, and mentorship from experienced cybersecurity professionals.`,
  heroHighlights: [
    "20-Week Intensive Bootcamp",
    "Beginner to Intermediate Level",
    "Live Instructor-Led Classes",
    "Weekly Practical Labs",
    "Enterprise Security Projects",
    "Career Coaching & Mentorship",
    "Capstone Project",
    "Certificate of Completion",
  ],
  metatags: `From IT foundations to enterprise security — learn, practice, and defend. Start your cybersecurity career with Utiva's hands-on, instructor-led bootcamp.`,
  duration: "5 Months",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/1UOD5bkxJiPoEEc4R1ijlmtgZpgYHFQ1z/view?usp=sharing",

  courseFormUrl: "courses/cybersecurity-bootcamp/fill-form",

  jobTitle: "Cybersecurity",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    image: Testimony2,
    name: "Ajibola Liyide",
    role: "Internal, External and Media Relations",
    testimony: `
    The Utiva training with Utiva has been challenging and inspiring. 
    Challenging because it is at the same time as the re-branding project in 
    my office. Inspiring because I have learnt a lot so far. The key point 
    is that the user experience is the most important factor to add value and 
    provide solutions. `,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Become a Job-Ready Cybersecurity Professional`,
    desc: `
    Master cybersecurity through an immersive 20-week instructor-led bootcamp designed to equip
    beginners and career changers with the practical skills required to secure modern organisations,
    from IT foundations to enterprise security.
    `,
  },

  keyOutcomesHeading:
    "Master the Skills to Detect, Defend, and Respond to Cyber Threats",

  keyOutcomes: [
    {
      label: "Discover",
      desc:
        "Understand cybersecurity fundamentals, enterprise infrastructure, networking, virtualisation, malware, and attack surfaces before learning how attackers operate.",
    },
    {
      label: "Secure",
      desc:
        "Protect Windows systems, mobile devices, enterprise networks, cloud environments, and web applications using modern defensive techniques.",
    },
    {
      label: "Detect",
      desc:
        "Analyse network traffic, identify vulnerabilities, investigate suspicious activities, and monitor enterprise environments using professional security tools.",
    },
    {
      label: "Respond",
      desc:
        "Perform incident response, digital forensics, business continuity planning, disaster recovery, and risk management while developing practical experience handling real-world security incidents.",
    },
  ],

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Cybersecurity Foundations",
      unitTag: "Weeks 1–3",
      unitDescription: `
      Learn IT fundamentals, the cybersecurity landscape, malware, enterprise security architecture,
      hardware virtualisation, network design, security devices, Windows hardening, mobile device
      security, and third-party risk assessment. Practical labs: Hyper-V, VMware, Oracle VirtualBox,
      Windows hardening, and Packet Tracer.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "IT Fundamentals",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Cybersecurity Overview",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Malware",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Enterprise Security Architecture",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Hardware Virtualization",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Network Design",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Security Devices",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Windows Hardening",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Mobile Device Security",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Third-Party Risk Assessment",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Application Security",
      unitTag: "Weeks 4–5",
      unitDescription: `
      Learn secure software development, web application security, API security, mobile application
      security, and secure development principles. Practical labs: Kali Linux, Windows Server, SQL
      injection, Cross-Site Scripting (XSS), OWASP ZAP, HostedScan, Pentest-Tools, Ostorlab, and
      BrowserStack.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Secure Software Development",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Web Application Security",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "API Security",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Mobile Application Security",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Secure Development Principles",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Security Engineering",
      unitTag: "Weeks 6–8",
      unitDescription: `
      Learn perimeter security, cloud security, security automation, network attacks, authentication,
      identity & access management, and defense-in-depth. Practical labs: software firewall
      configuration, man-in-the-middle attack simulation, and Wireshark network analysis.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Perimeter Security",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Cloud Security",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Security Automation",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Network Attacks",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Authentication",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Identity & Access Management",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Defense-in-Depth",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Risk & Vulnerability Management",
      unitTag: "Weeks 9–10",
      unitDescription: `
      Learn risk assessment, vulnerability management, monitoring & auditing, cryptography, hashing,
      and public key infrastructure. Practical labs: enterprise risk assessment, Nessus vulnerability
      scanning, file hash verification, and classical encryption exercises.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Risk Assessment",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Vulnerability Management",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Monitoring & Auditing",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Cryptography",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Hashing",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Public Key Infrastructure",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Enterprise Security Operations",
      unitTag: "Weeks 11–15",
      unitDescription: `
      Learn security protocols, business continuity, disaster recovery, social engineering, incident
      response, digital forensics, security frameworks, and security policies. Practical labs: RSA key
      generation, Windows credential analysis, phishing simulation, digital forensics investigation,
      and Active Directory deployment.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Security Protocols",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Business Continuity",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Disaster Recovery",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Social Engineering",
          featureDescription: ``,
        },
        {
          featureIcon: Icon1,
          featureTitle: "Incident Response",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Digital Forensics",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Security Frameworks",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Security Policies",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Career Development & Capstone",
      unitTag: "Weeks 16–20",
      unitDescription: `
      Learn cybersecurity career paths, portfolio development, professional communication, and
      industry best practices, then complete a comprehensive enterprise cybersecurity capstone
      covering enterprise network design, vulnerability assessment, web application security testing,
      risk assessment, security architecture, incident response planning, Active Directory deployment,
      and a final technical presentation.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Cybersecurity Career Paths",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Portfolio Development",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Professional Communication",
          featureDescription: ``,
        },
        {
          featureIcon: Icon4,
          featureTitle: "Industry Best Practices",
          featureDescription: ``,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Olopade Babawale Charles",
      coachRole: "Senior Cybersecurity Analyst",
    },
    {
      coachId: 2,
      coachImage: PrincewillImage,
      coachName: "Princewill Ogbu",
      coachRole: "AI Automation Practice Lead",
    },
    {
      coachId: 3,
      coachImage: OmodaraImage,
      coachName: "Oluwaseun Omodara",
      coachRole: "Senior Product and Digital Marketer",
    },
    {
      coachId: 4,
      coachImage: IdaraImage,
      coachName: "Idara",
      coachRole: "Data School Support Person",
    },
    {
      coachId: 5,
      coachImage: AmandaImage,
      coachName: "Amanda Iyoha",
      coachRole: "Cybersecurity Support",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Learn Through Real Attacks",
      modelDescription:
        "Work through realistic attack scenarios that teach you how cybercriminals exploit systems and how defenders stop them.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Build Enterprise Security Skills",
      modelDescription:
        "Configure secure environments, deploy security controls, perform vulnerability assessments, and strengthen enterprise infrastructure.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Practice Weekly",
      modelDescription:
        "Every module includes practical laboratory sessions that reinforce classroom learning through hands-on implementation.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Receive Expert Mentorship",
      modelDescription:
        "Learn directly from experienced cybersecurity professionals who provide continuous feedback and guidance throughout your learning journey.",
    },
  ],

  studentTestimonies: [
    {
      id: 2,
      linkedIn: "",
      image: Testimony2,
      firstname: "Ajibola",
      lastname: "Liyide",
      company: "Internal, External and Media Relations",
      testimony: `
        The Utiva training with Utiva has been challenging and inspiring. Challenging
        because it is at the same time as the re-branding project in my office. Inspiring because
        I have learnt a lot so far. The key point is that the user experience is the most
        important factor to add value and provide solutions.
        `,
    },
    {
      id: 3,
      linkedIn: "",
      image: OyinImage,
      firstname: "Oyin",
      lastname: "Damola",
      company: "",
      testimony: `
        I really enjoyed my learning experience at Utiva. The classes were practical, engaging, and easy to follow.
        My trainer, Babawale Olopade, did an amazing job. He explained everything clearly, made complex topics simple,
        and was always ready to help. I studied Cybersecurity and I feel way more confident with the skills I've gained.
        Utiva truly prepares you for real tech opportunities. I highly recommend Utiva to anyone serious about growing in tech!
        `,
    },
    {
      id: 4,
      linkedIn: "",
      image: JumokeImage,
      firstname: "Jumoke",
      lastname: "Zainab",
      company: "",
      testimony: `
        My experience at Utiva has been good so far. I'm studying cybersecurity under Mr. Babawale Olopade and the
        training has been insightful and practical so far, the training environment has been supportive and I have
        gained valuable knowledge.
        `,
    },
    {
      id: 5,
      linkedIn: "",
      image: OkechukwuImage,
      firstname: "Okechukwu",
      lastname: "Orji-Titus",
      company: "",
      testimony: `
        I am learning a cybersecurity course under the guidance of Babawale Olopade, and it has been an eye-opening
        experience. Today already exposed me to key foundational areas such as routers, hubs, switches, security
        principles, hypervisors, and practical network design. I am truly excited about the future version of myself
        in cybersecurity and motivated to keep learning and growing in this field.
        `,
    },
    {
      id: 6,
      linkedIn: "",
      image: BanjoImage,
      firstname: "Banjo",
      lastname: "Oluwatobiloba",
      company: "",
      testimony: `
        What a superb training session on Cybersecurity hosted by Olopade Babawale, and it was nothing short of
        excellent. The session was well-structured, insightful, and engaging from start to finish. Olopade combined
        solid theoretical knowledge with hands-on practical exercises, making complex cybersecurity concepts easy to
        understand and apply. The practical sessions, in particular, were very impactful. His clear explanations,
        interactive teaching style, and readiness to address participants' questions made the learning experience
        both enjoyable and highly educational. Overall, it was a valuable and eye-opening session that left me more
        confident in my cybersecurity knowledge and skills. I look forward to more.
        `,
    },
    {
      id: 7,
      linkedIn: "",
      image: YemiImage,
      firstname: "Yemi",
      lastname: "Ilurimi",
      company: "",
      testimony: `
        Trainer Babawale has been interesting and exciting. The class is stimulating me to do more and discover more
        depth into cybersecurity.
        `,
    },
    {
      id: 8,
      linkedIn: "",
      image: NicholasImage,
      firstname: "Nicholas",
      lastname: "Ehichioyame",
      company: "",
      testimony: `
        I joined Utiva because it came highly recommended without a tech background and I can see now that they are
        really good and rank among the best in the cyber security training institutes in Nigeria and beyond. I'm
        leveraging on the in-depth, wide experience of my trainer, Mr Babawale who leads us in the interactive
        sessions online classes and also makes himself available to explain and organize extra tutorials to make
        sure we all understand the course. This has made my training and learning so far very easy, and memorable.
        Shout out to Utiva, you are the best.
        `,
    },
    {
      id: 9,
      linkedIn: "",
      image: OvianihinImage,
      firstname: "Ovianihin",
      lastname: "Nwonodi",
      company: "",
      testimony: `
        Cybersecurity coach - Babawale Olopade is a great teacher. Making sure that he carries all his tutors along.
        Well done coach!
        `,
    },
    {
      id: 10,
      linkedIn: "",
      image: AdebamboImage,
      firstname: "Adebambo",
      lastname: "Olubusayo",
      company: "",
      testimony: `
        It was a very good experience in studying cyber security because initially I really didn't enjoy it, it was
        just direct teaching. When the new lecturer started (Mr. Babawale Olopade) it started making sense and more
        interesting to me. He made sure we all understand and shows a lot of practicals in order for us to get the
        exposure to all the applications we need. The amazing part is that he still attends to any issues brought
        forward to him.
        `,
    },
    {
      id: 11,
      linkedIn: "",
      image: JoshuaImage,
      firstname: "Joshua",
      lastname: "Abiamowie",
      company: "",
      testimony: `
        I'm currently taking a cyber security class on Utiva, and it's been a great learning experience so far. The
        lessons are clear and beginner-friendly, with practical examples that make the topics easy to understand.
        I've already learned a lot about online threats, password security, and basic protection tools. The
        instructor (Mr Babawale) explains things well, and the content is engaging. I'm looking forward to
        completing the course and building more skills in this field.
        `,
    },
    {
      id: 12,
      linkedIn: "",
      image: KoredeImage,
      firstname: "Korede",
      lastname: "Soyinka",
      company: "",
      testimony: `
        Mr Wale my cyber security teacher has been really helpful even outside of class; his dedication to making me
        understand and confident about the course is really outstanding.
        `,
    },
    {
      id: 13,
      linkedIn: "",
      image: StephnoraImage,
      firstname: "Stephnora",
      lastname: "Chinaza",
      company: "",
      testimony: `
        I recently had the opportunity to participate in UTIVA's cybersecurity training, and I must say it was an
        exceptional experience! The training was comprehensive, impactful and engaging, covering a wide range of
        topics from threat analysis to incident response, vulnerability management and penetration testing etc. My
        amiable instructor Mr Babawale Olopade's role cannot be overemphasized, he demonstrated a deep understanding
        of cybersecurity concepts and was able to convey complex ideas in a clear and concise manner. I'm so grateful
        for the gift of him in my learning journey and also for his great mentorship. I particularly appreciated the
        hands-on exercises and real-world examples that helped reinforce the learning material. Overall, I would
        highly recommend UTIVA's cybersecurity training to anyone looking to enhance their knowledge and skills in
        this field.
        `,
    },
    {
      id: 14,
      linkedIn: "",
      image: NwokoloImage,
      firstname: "Nwokolo",
      lastname: "Chinaza",
      company: "",
      testimony: `
        The live classes are really engaging; it helps me understand the uploaded videos more and I do enjoy
        cybersecurity class. Thank you, Mr Babawale.
        `,
    },
    {
      id: 15,
      linkedIn: "",
      image: WisdomImage,
      firstname: "Wisdom",
      lastname: "Chukwuemeka Hycent",
      company: "",
      testimony: `
        I'm a cyber security student with one of the best trainers I have met; Babawale.
        `,
    },
    {
      id: 16,
      linkedIn: "",
      image: KunleImage,
      firstname: "Kunle",
      lastname: "Bamidele",
      company: "",
      testimony: `
        Great experience especially with the tutor of cybersecurity Babawale Olopade, very impactful.
        `,
    },
    {
      id: 17,
      linkedIn: "",
      image: EnaImage,
      firstname: "Ena",
      lastname: "Ifehwo",
      company: "",
      testimony: `
        I am studying cybersecurity at Utiva. Being an amateur with no prior knowledge of the course, I can say I've
        gained some new knowledge/skills during this learning period. Overall, it's been a good experience.
        `,
    },
    {
      id: 18,
      linkedIn: "",
      image: KennethImage,
      firstname: "Kenneth",
      lastname: "Aba",
      company: "",
      testimony: `
        My experience at UTIVA so far has been great. I'm currently enrolled in the Cybersecurity class, and I must
        say the instructor is experienced, knowledgeable, and flexible. I enjoy the classes because he ensures
        everyone stays engaged and keeps up with the material. I'm looking forward to more hands-on labs to further
        develop my practical skills, but overall, it has been a very positive experience.
        `,
    },
    {
      id: 19,
      linkedIn: "",
      image: CynthiaImage,
      firstname: "Cynthia",
      lastname: "Anita",
      company: "",
      testimony: `
        The Utiva training on cyber security has been okay so far, I like the fact that they always check up on you
        to see if you are having any challenge and they are ready to assist you get the best of the training. Kudos
        to them for that regard.
        `,
    },
    {
      id: 20,
      linkedIn: "",
      image: BabatundeImage,
      firstname: "Babatunde",
      lastname: "Salawu",
      company: "",
      testimony: `
        The Cybersecurity coach, Mr Olopade Babatunde's class is very detailed and I have been enjoying his class
        and teachings so far.
        `,
    },
    {
      id: 21,
      linkedIn: "",
      image: BenjaminImage,
      firstname: "Benjamin",
      lastname: "Yusuf",
      company: "",
      testimony: `
        This was one of the most interactive, easy to learn and understand tech class I've had. Mr Olopade Babawale
        is a very good instructor who made sure everyone was carried along throughout the class, attending to
        everyone's questions and made sure everyone understood what he was explaining word for word before moving to
        the next phase. As a beginner I know I gained a lot from his cybersecurity class.
        `,
    },
    {
      id: 22,
      linkedIn: "",
      image: PreciousImage,
      firstname: "Precious",
      lastname: "Emmanuel",
      company: "",
      testimony: `
        Mr. Olopade makes learning cybersecurity fun and easy to understand. He's very knowledgeable and also funny,
        which keeps the class engaging. I totally recommend!
        `,
    },
    {
      id: 23,
      linkedIn: "",
      image: FadeelahImage,
      firstname: "Fadeelah",
      lastname: "Yusuf",
      company: "",
      testimony: `
        My experience with the Utiva Cybersecurity program has been incredibly valuable. The course structure is
        beginner-friendly yet comprehensive, covering both the fundamentals and real-world applications of
        cybersecurity. A special thank you to my trainer, Mr. Babawale, for his excellent teaching style. He
        explained complex concepts in a clear and practical way, always making time to answer questions and provide
        support. His guidance truly made the learning process enjoyable and effective. I feel more confident in my
        understanding of cybersecurity and grateful to have been part of this training.
        `,
    },
  ],

  portofolio: {
    title: "Build a Portfolio That Gets You Hired",
    description: `
    By graduation, you'll have completed practical projects that demonstrate your ability to
    solve real cybersecurity challenges.
      `,

    deliverables: [
      "Enterprise Risk Assessment Report",
      "Vulnerability Assessment Report",
      "Penetration Testing Report",
      "Network Security Architecture",
      "Active Directory Deployment",
      "Incident Response Plan",
      "Business Continuity Plan",
      "Disaster Recovery Strategy",
      "Digital Forensics Investigation Report",
      "Security Policies & Procedures",
      "Final Enterprise Capstone Project",
    ],

    name: "James Miles",
    // image: PortfolioUserAvatar,
    // portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Cybersecurity Bootcamp Certification",
    description: `
    Upon completing Utiva's Cybersecurity Bootcamp, you'll receive an 
    industry-recognized, professional Cybersecurity Program certification to 
    share with your network and showcase all that you've 
    learned. Utiva certificates are formatted for sharing on LinkedIn 
      `,
  },

  // videoTestimonial: "https://youtu.be/TQrD6jyYqxs",
  // videoTestimonial: "https://www.youtube.com/embed/z43uJREQj4w",
  videoTestimonial: "https://www.youtube.com/embed/a9XF4vTlLBc",
  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Analytics Bootcamp",
      courseDescription: `This program is designed to help you apply the important ML techniques for solving 
      real business problems and also help you make key data-driven decisions for business growth.  `,
      courseUrl: "/courses/data-analytics-bootcamp",
    },
  ],
};
